export default "__VITE_ASSET__CLQ1iKIs__"